import { AppComponent } from './app';
import style from './style.scss';

import { DATA_AREAS, DATA_EVENTS, DATA_MONSTERS, DATA_STATUS } from './data/sources';

document.getElementsByClassName('preloader')[0]?.remove();

// Add style.
let s = document.createElement('style');
s.appendChild(document.createTextNode(style));
document.head.appendChild(s);

// App component.
let app = new AppComponent();
window.document.body.append(app);

DATA_AREAS.forEach((cls) => {

    if (cls.name === '3 The House Vesparin' || cls.name === '6 Isle of Talos' || cls.name === '7 The Godscar Wastes')
        cls.expansion = 4;

    if (cls.name === 'Spine of Night')
        cls.name = '10 Spine of Night';

    cls.events = [];
    if (cls.campfires > 0)
        cls.events.push({
            name: 'Campfire',
            qty: cls.campfires
        });
    if (cls.shrines > 0)
        cls.events.push({
            name: 'Shrine',
            qty: cls.shrines
        });
    if (cls.opportunities > 0)
        cls.events.push({
            name: 'Opportunity',
            qty: cls.opportunities
        });
    if (cls.npcs > 0)
        cls.events.push({
            name: 'NPC',
            qty: cls.npcs
        });

    return cls;
});

DATA_MONSTERS.sort((a, b) => {
    if (a.name > b.name) return 1;
    if (a.name < b.name) return -1;
    return 0;
});

DATA_STATUS.sort((a, b) => {
    if (a.name > b.name) return 1;
    if (a.name < b.name) return -1;
    return 0;
});

DATA_EVENTS.sort((a, b) => {
    if ((a.caption || a.name) > (b.caption || b.name)) return 1;
    if ((a.caption || a.name) < (b.caption || b.name)) return -1;
    return 0;
});

window.addEventListener('load', () => {
    gtag('config', 'G-5NRD9EMFGT', {
        'send_page_view': false,
        'app_name': 'Blightbane.io',
        'app_version': '0.19.6',
        client_storage: 'none'
    });
    if ('serviceWorker' in navigator && window.location.href.indexOf('localhost') === -1) {
        navigator.serviceWorker.register('/service-worker.js?v=0.19.6').then(registration => {
            console.log('SW registered: ', registration);
        }).catch(registrationError => {
            console.log('SW registration failed: ', registrationError);
        });
    }
});